import { documentDetailSections } from 'azshared';
import React, { useCallback } from 'react';

interface SignatureTabBarProps {
  text: string;
  isSelected: boolean;
  section: documentDetailSections;
  onTabSelected: (section: documentDetailSections) => void;
}

export const SignatureAreaDetailTabElement = (props: SignatureTabBarProps) => {
  const { text, isSelected, section, onTabSelected } = props;

  const onButtonClick = useCallback(() => onTabSelected(section), [section, onTabSelected]);

  return (
    <button className='signature-tab-bar' aria-selected={isSelected} onClick={onButtonClick}>
      {text}
    </button>
  );
};
